(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const collectionUrl = new URL(window.location.href);

  if (collectionUrl.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(collectionUrl.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /*
   * Group all colour cards belonging to the same parent product.
   *
   * Shopify still controls the parent-product order through:
   * Featured, Best selling, Price, Date, Alphabetical, and other filters.
   *
   * Example:
   * The Essential Burkini — Black
   * The Essential Burkini — Azure
   * The Essential Burkini — Ivory
   *
   * Then the next product and all of its colour cards.
   */
  (() => {
    const BASE_INDEX_ATTRIBUTE = 'data-product-group-base-index';
    const PRODUCT_KEY_ATTRIBUTE = 'data-product-group-key';

    let sortQueued = false;
    let isApplyingInternalSort = false;
    let forceFreshBaseOrder = true;

    const getGridItems = (grid) =>
      Array.from(grid.children).filter((child) =>
        child.classList?.contains('product-grid__item')
      );

    const findProductGrids = () => {
      const grids = [];

      document.querySelectorAll('results-list').forEach((resultsList) => {
        resultsList.querySelectorAll('ul, ol').forEach((list) => {
          if (list.querySelector(':scope > .product-grid__item')) {
            grids.push(list);
          }
        });
      });

      return grids;
    };

    const getProductKey = (item) => {
      const storedKey = item.getAttribute(PRODUCT_KEY_ATTRIBUTE);

      if (storedKey) {
        return storedKey;
      }

      const nestedVariantCard = item.querySelector(
        '.variant-product-card[data-product-id]'
      );

      const nestedProductCard = item.querySelector(
        'product-card[data-product-id]'
      );

      const productId =
        item.getAttribute('data-product-id') ||
        nestedVariantCard?.getAttribute('data-product-id') ||
        nestedProductCard?.getAttribute('data-product-id');

      /*
       * Product ID is the safest grouping key. A title fallback is included
       * only for cards where the ID is unavailable.
       */
      const titleElement = item.querySelector(
        '.variant-product-card__title, .product-card__title, h3'
      );

      const titleFallback = String(titleElement?.textContent || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-');

      const productKey = productId
        ? `product-${productId}`
        : `title-${titleFallback}`;

      if (productKey !== 'title-') {
        item.setAttribute(PRODUCT_KEY_ATTRIBUTE, productKey);
      }

      return productKey;
    };

    const captureBaseOrder = (grid, resetAll) => {
      const items = getGridItems(grid);

      if (resetAll) {
        items.forEach((item, index) => {
          item.setAttribute(BASE_INDEX_ATTRIBUTE, String(index));
          item.removeAttribute(PRODUCT_KEY_ATTRIBUTE);
        });

        return;
      }

      let nextIndex = items.reduce((highestIndex, item) => {
        const existingIndex = Number(
          item.getAttribute(BASE_INDEX_ATTRIBUTE)
        );

        return Number.isFinite(existingIndex)
          ? Math.max(highestIndex, existingIndex + 1)
          : highestIndex;
      }, 0);

      /*
       * Infinite-scroll cards are appended in Shopify's current order.
       * Existing indexes remain unchanged; only new cards get later indexes.
       */
      items.forEach((item) => {
        if (!item.hasAttribute(BASE_INDEX_ATTRIBUTE)) {
          item.setAttribute(BASE_INDEX_ATTRIBUTE, String(nextIndex));
          item.removeAttribute(PRODUCT_KEY_ATTRIBUTE);
          nextIndex += 1;
        }
      });
    };

    const sortGridByProduct = (grid, resetBaseOrder) => {
      captureBaseOrder(grid, resetBaseOrder);

      const items = getGridItems(grid);

      if (items.length < 2) return;

      const baseOrderedItems = [...items].sort((firstItem, secondItem) => {
        return (
          Number(firstItem.getAttribute(BASE_INDEX_ATTRIBUTE)) -
          Number(secondItem.getAttribute(BASE_INDEX_ATTRIBUTE))
        );
      });

      /*
       * Product groups follow the first occurrence in Shopify's current sort.
       * Therefore Featured remains Featured, while all variants of each product
       * are moved directly beside that product's first card.
       */
      const productOrder = new Map();

      baseOrderedItems.forEach((item) => {
        const productKey = getProductKey(item);

        if (productKey && !productOrder.has(productKey)) {
          productOrder.set(productKey, productOrder.size);
        }
      });

      const sortedItems = [...items].sort((firstItem, secondItem) => {
        const firstProductKey = getProductKey(firstItem);
        const secondProductKey = getProductKey(secondItem);

        const firstGroupIndex = productOrder.has(firstProductKey)
          ? productOrder.get(firstProductKey)
          : productOrder.size;

        const secondGroupIndex = productOrder.has(secondProductKey)
          ? productOrder.get(secondProductKey)
          : productOrder.size;

        if (firstGroupIndex !== secondGroupIndex) {
          return firstGroupIndex - secondGroupIndex;
        }

        /*
         * Keep each product's colour variants in their original card order.
         */
        return (
          Number(firstItem.getAttribute(BASE_INDEX_ATTRIBUTE)) -
          Number(secondItem.getAttribute(BASE_INDEX_ATTRIBUTE))
        );
      });

      const orderChanged = sortedItems.some(
        (item, index) => item !== items[index]
      );

      if (!orderChanged) return;

      isApplyingInternalSort = true;

      const fragment = document.createDocumentFragment();

      sortedItems.forEach((item) => {
        fragment.appendChild(item);
      });

      grid.appendChild(fragment);

      queueMicrotask(() => {
        isApplyingInternalSort = false;
      });
    };

    const sortAllProductGroups = () => {
      const resetBaseOrder = forceFreshBaseOrder;
      forceFreshBaseOrder = false;

      findProductGrids().forEach((grid) => {
        sortGridByProduct(grid, resetBaseOrder);
      });
    };

    const queueSort = () => {
      if (sortQueued) return;

      sortQueued = true;

      requestAnimationFrame(() => {
        sortQueued = false;
        sortAllProductGroups();
      });
    };

    const mutationContainsGridCards = (mutation) => {
      const nodes = [
        ...Array.from(mutation.addedNodes),
        ...Array.from(mutation.removedNodes),
      ];

      return nodes.some((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return false;

        return (
          node.matches?.('.product-grid__item, ul, ol, results-list') ||
          node.querySelector?.('.product-grid__item')
        );
      });
    };

    const initializeProductGrouping = () => {
      forceFreshBaseOrder = true;
      queueSort();

      const collectionComponent = document.querySelector(
        'collection-component'
      );

      if (!collectionComponent) return;

      const observer = new MutationObserver((mutations) => {
        if (isApplyingInternalSort) return;

        const relevantMutations = mutations.filter(
          mutationContainsGridCards
        );

        if (relevantMutations.length === 0) return;

        /*
         * A removed grid/card usually means Shopify refreshed the results after
         * a filter or sort change. Capture the new server order as the new base.
         */
        const replacedExistingCards = relevantMutations.some((mutation) =>
          Array.from(mutation.removedNodes).some((node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) return false;

            return (
              node.matches?.('.product-grid__item, ul, ol, results-list') ||
              node.querySelector?.('.product-grid__item')
            );
          })
        );

        if (replacedExistingCards) {
          forceFreshBaseOrder = true;
        }

        queueSort();
      });

      observer.observe(collectionComponent, {
        childList: true,
        subtree: true,
      });

      collectionComponent.addEventListener('change', (event) => {
        const target = event.target;

        if (
          target instanceof HTMLSelectElement &&
          target.name === 'sort_by'
        ) {
          forceFreshBaseOrder = true;
        }
      });

      document.addEventListener('shopify:section:load', () => {
        forceFreshBaseOrder = true;
        queueSort();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeProductGrouping,
        { once: true }
      );
    } else {
      initializeProductGrouping();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
